const AvailableWarehouseIcon = () => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            d="M11.9791 17.9512C7.86375 17.9512 3.98596 16.0236 1.50148 12.7428L0.938965 12L1.50148 11.2572C3.98601 7.97647 7.86375 6.04885 11.9791 6.04885C16.0945 6.04885 19.9723 7.97647 22.4568 11.2572L23.0193 12L22.4568 12.7428C19.9723 16.0236 16.0945 17.9512 11.9791 17.9512Z"
            stroke="#000000"
            strokeMiterlimit={10}
        />
        <path
            d="M0.70166 6.44605V3.80421H3.34346M0.70166 17.554V20.1957H3.34346M23.2983 17.554V20.1957H20.6564M23.2983 6.44605V3.80421H20.6564M14.6203 13.5399V10.4601L11.9532 8.92024L9.28607 10.4601V13.5399L11.9532 15.0798L14.6203 13.5399Z"
            stroke="#000000"
            strokeMiterlimit={10}
        />
        <path
            d="M9.28613 10.4601L10.6197 11.23L11.9532 12M11.9532 12L14.6204 10.4601M11.9532 12V15.0798"
            stroke="#000000"
            strokeMiterlimit={10}
        />
    </svg>
);
export default AvailableWarehouseIcon;
